import React, { useState, useEffect } from 'react';
import { Modal, Box, Button, Typography, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import axios from 'axios';
import { toast } from 'react-toastify';
import Circular from './Circular';


const ChangeAccountCategoryModal = ({ open, onClose, account, render, setRender }) => {
    const [categories, setCategories] = useState([]);
    const [lock, setLock] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const ToasterToggle = JSON.parse(localStorage.getItem("Toaster"))
    useEffect(() => {
        if (open) {
            axios.get(`${process.env.REACT_APP_BASE_URL}category/all`,{
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
                .then((response) => {
                    setCategories(response.data);
                })
                .catch((error) => console.error("Failed to fetch categories:", error));
        }
    }, [open]);

    const handleAssign = () => {
        setLock(true);
        axios.post(`${process.env.REACT_APP_BASE_URL}category/change-category`,{
            accountId: account._id,
            categoryId: selectedCategory
             }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }}).then(() => {
            if (ToasterToggle) {
                toast.success('Account assigned to category successfully');
            } setRender(!render);
            onClose();
        }).catch((error) => {
            if (ToasterToggle) {
                toast.error(error.response.data.message || 'Failed to assign Account to category');
            }
            console.error(error);
            setLock(false);
        });
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4,
                borderRadius: 1,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}>
                <Typography variant="h6" sx={{ color: "black" }}>Change Account's Category</Typography>
                <FormControl fullWidth>
                    <InputLabel>Select Category</InputLabel>
                    <Select
                        value={selectedCategory}
                        label="Select Category"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        {categories?.map((category) => (
                            <MenuItem key={category._id} value={category._id}>{category.categoryName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {lock ? <> <Circular /> </>
                    :
                    <Button variant="contained" onClick={handleAssign}>Change</Button>
                }
            </Box>
        </Modal>
    );
};

export default ChangeAccountCategoryModal;

